import { format, parseISO } from 'date-fns'
import { toZonedTime } from 'date-fns-tz'
import { getSelectedAdAccountTimezone } from '../modules/selectors/adAccounts'

export const MINIMAL_PAST_DATE = '01/01/2021'

// initialDatePeriod doesn't highlight any date in DateRange component
export const initialDatePeriod = {
  startDate: null,
  endDate: new Date(''),
  key: 'selection'
}

export const getTimezoneDate = (date, platform) => {
  // timezone should be used from selectedAdAccount
  const timezone = getSelectedAdAccountTimezone(platform)
  return toZonedTime(date, timezone)
}

export const DATES_FORMAT_BE = 'yyyy-MM-dd'
export const DATES_FORMAT_SHORT = 'dd MMM yy'
export const DATES_FORMAT_LONG = 'dd MMMM yyyy'
export const DATES_FORMAT_FULL_YEAR_SHORT_MONTH = 'dd MMM yyyy'
export const DATES_FORMAT_SKIP_YEAR = 'dd MMM'
export const DATES_FORMAT_MONTH_DAY = 'MMM dd'
export const DATES_FORMAT_FULL_YEAR = 'dd MMM, yyyy'
export const DATES_FORMAT_MONTH_DAY_YEAR = 'MMM dd, yyyy'
export const DATES_FORMAT_DETAILED = 'dd MMM yyyy, HH:mm'

export const scheduleSelectorMondayDate = '2019-06-10T00:00:00'

export const formatDateBE = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  return format(date, DATES_FORMAT_BE)
}

export const formatDateShort = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  return format(date, DATES_FORMAT_SHORT)
}

export const formatDateSkipYear = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  return format(date, DATES_FORMAT_SKIP_YEAR)
}

export const formatDateFullYear = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  return format(date, DATES_FORMAT_FULL_YEAR)
}

export const formatDateDetailed = date => {
  if (typeof date === 'string') {
    date = parseISO(date)
  }
  return format(date, DATES_FORMAT_DETAILED)
}
